import { useEffect } from 'react';

const getGlobalScrollNode = () => {
    return document.querySelector('.ladle-main') ?? document.querySelector('.scrollable--root');
};

/**
 * A custom hook that listens to body scroll events and triggers a callback
 *  when a scroll event occurs.
 *
 * Note: in case the scrollable element is not the body, you should add a `.scrollable--root` class to the
 *  main scrollable element. In this case we will listen to scroll events on both the body and the main scrollable element.
 */
export const useListenBodyScroll = (callback: () => void, deps: React.DependencyList = []): void => {
    useEffect(() => {
        const handleScroll = () => {
            callback();
        };

        window.addEventListener('scroll', handleScroll);

        const node = getGlobalScrollNode();

        if (node) {
            node.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);

            if (node) {
                node.removeEventListener('scroll', handleScroll);
            }
        };
    }, [...deps]);
};
